import React from "react";
import { Table } from "reactstrap";
import { addClassName } from "../../../Utils/Add-ClassName.js";
import { calcPercentage } from "../../../Utils/calculate-progress.js";
import RenderModals from "../../Modals/modal";
import EditModal from "./Invitation-Modal/Edit-Modal/EditModal";
import DeleteModal from "./Invitation-Modal/Delete-Modal/DeleteModal";
import editIcon from "../../../../images/new-images/edit-green.svg";
import editdisable from "../../../../images/new-images/edit-disable.svg";
import deleteIcon from "../../../../images/new-images/delete.svg";
import reminderIcon from "../../../../images/new-images/reminder-blue.svg";
import completed from "../../../../images/new-images/completed.png";
import reminderDisableIcon from "../../../../images/new-images/reminder-disable.svg";
import RenderinviteRespondantsModal from "./Invitation-Modal/Invite-respondants-modal";
import "./Sent.css";
import Buttons from "../Sent/Buttons/Buttons";
import MyinvitationsEmpty from "../Invitations-Empty";
import Renderconfirmmessagemodal from "../../Invitations/Sent/Invitation-Modal/confirm-modal";

const Sentrespondantsfiltered = (props) => {

  const editButtonControll = (
    respondentRelationship,
    groupId,
    uid,
    rid,
    respondentEmail,
    is_submited,
    respondantsStatus
  ) => {
    if (is_submited === true || respondantsStatus === "In progress") {
      return <img style={{ cursor: "not-allowed" }} src={editdisable} />;
    } else {
      return (
        <div>
          <img
            onClick={() =>
              props.handleEditModal(
                respondentEmail,
                respondentRelationship,
                uid,
                rid,
                groupId
              )
            }
            src={editIcon}
          />
          <RenderModals
            assessmentModal={props.editModal}
            handleModalClose={props.handleModalClose}
            modalHeading="EDIT RELATIONSHIP"
          >
            <EditModal
              handleEditModalSubmit={props.handleEditModalSubmit}
              respondentEmail={props.respondentEmail}
              respondentRelationship={props.respondentRelationship}
              dropDownOptions={props.dropDownOptions}
              assessmentUserId={props.assessmentUserId}
              accessorGroupId={props.accessorGroupId}
              relationShipId={props.relationShipId}
              handleModalClose={props.handleModalClose}
              filteredSentRespondants={props.filteredSentRespondants}
              handleDropdownOptions={props.handleDropdownOptions}
              sentRespondantsId={props.sentRespondantsId}
              sentRespondantsFilteredId={props.sentRespondantsFilteredId}
            />
          </RenderModals>
        </div>
      );
    }
  };

  const reminderButtonControll = (
    getStatus,
    userId,
    respondantsId,
    respondantEmail
  ) => {
    if (getStatus === "Completed" || getStatus === "In progress") {
      return (
        <img style={{ cursor: "not-allowed" }} src={reminderDisableIcon} />
      );
    } else {
      return (
        <img
          src={reminderIcon}
          onClick={() =>
            props.handleReminder(userId, respondantsId, respondantEmail)
          }
        />
      );
    }
  };

  const deleteButtonControl = (
    respondantGetStatus,
    respondentEmail,
    userId,
    respondantsId,
    isAdminCreated
  ) => {
    if (
      respondantGetStatus === "Completed" ||
      respondantGetStatus === "In progress"
    ) {
      return (
        <img
          className="delete-Icon"
          src={deleteIcon}
          style={{ opacity: "0.3", cursor: "not-allowed" }}
        />
      );
    } else if (isAdminCreated === true) {
      return (
        <img
          className="delete-Icon"
          src={deleteIcon}
          style={{ opacity: "0.3", cursor: "not-allowed" }}
        />
      );
    } else {
      return (
        <div>
          <img
            onClick={() =>
              props.handleDeleteModal(respondentEmail, userId, respondantsId)
            }
            className="delete-Icon"
            src={deleteIcon}
          />
          <RenderModals
            assessmentModal={props.deleteModal}
            handleModalClose={props.handleModalClose}
            modalHeading="DELETE RESPONDENT"
          >
            <DeleteModal
              handleModalClose={props.handleModalClose}
              handleDeleteRequest={props.handleDeleteRequest}
              respondentEmail={props.respondentEmail}
              respondantUserAssessmentId={props.respondantUserAssessmentId}
              respondantIndividualId={props.respondantIndividualId}
            />
          </RenderModals>
        </div>
      );
    }
  };

  return (
    <div className="sent-Tab">
      <Buttons
        respondantStatus={props.respondantStatus}
        handleInvitationsModal={props.handleInvitationsModal}
        minRespondants={props.minRespondants}
        sentRespondants={props.sentRespondants}
        getRespondantStatus={props.getRespondantStatus}
        batchMinRespondants={props.batchMinRespondants}
        sentRespondantsId={props.sentRespondantsId}
        filteredSentRespondants={props.filteredSentRespondants}
        idOfParticipant={props.idOfParticipant}
        isMultiRater={props.isMultiRater}
      />

      <RenderModals
        assessmentModal={props.respondentInvitationsModal}
        handleModalClose={props.handleModalClose}
        modalHeading="INVITE RESPONDENT"
      >
        <RenderinviteRespondantsModal
          inputFields={props.inputFields}
          handleInputFields={props.handleInputFields}
          handleRelationDropdown={props.handleRelationDropdown}
          dropDownOptions={props.dropDownOptions}
          handleInvitationsEmail={props.handleInvitationsEmail}
          isChecked={props.isChecked}
          isDisabled={props.isDisabled}
          handleModalFormSubmit={props.handleModalFormSubmit}
          handleModalSubmit={props.handleModalSubmit}
          handleModalClose={props.handleModalClose}
        />
      </RenderModals>
      <RenderModals
        assessmentModal={props.respondantConfirmModal}
        handleModalClose={props.handleModalClose}
        modalHeading="RESPONDENT DETAILS"
      >
        <Renderconfirmmessagemodal
          handleModalClose={props.handleModalClose}
          invitationsSuccessMessage={props.invitationsSuccessMessage}
        />
      </RenderModals>
      <div
        style={
          props.filteredSentRespondants &&
            (props.filteredSentRespondants.respondents.length == 1 ||
              props.filteredSentRespondants.respondents.length == 2 ||
              props.filteredSentRespondants.respondents.length == 3)
            ? { height: "auto" }
            : { height: "320px", overflowY: "auto" }
        }
        className="custom-height"
      >
        {props.filteredSentRespondants &&
          props.filteredSentRespondants.respondents.length == 0 ? (
          <MyinvitationsEmpty emptyText="You do not have any respondants yet." />
        ) : (
          <Table>
            <thead>
              <tr>
                <th className="tableHeaders">Respondents</th>
                <th className="tableHeaders">Relationship</th>
                <th className="tableHeaders">Assessment Expiry Date</th>
                <th className="tableHeaders">Status</th>
                <th className="tableHeaders">Manage Actions</th>
                <th className="tableHeaders">Send Reminder</th>
              </tr>
            </thead>
            <tbody>
              <React.Fragment>
                {props.filteredSentRespondants &&
                  props.filteredSentRespondants.respondents.map(
                    (respondentData, index) => {
                      return (
                        <tr key={index}>
                          <td>{respondentData.respondent__email}</td>
                          <td>
                            {respondentData.assessor_group__assessor_name}
                          </td>
                          <td>{respondentData.user_assessment__expiry_date}</td>
                          <td>
                            {respondentData.assessment_status__status_name ===
                              "In progress" ? (
                              <div
                                style={{ display: "flex", gap: "10px" }}
                                className={
                                  "assessment-status-text " +
                                  addClassName(
                                    respondentData.assessment_status__status_name
                                  )
                                }
                              >
                                {respondentData.assessment_status__status_name}
                                {calcPercentage(
                                  respondentData.user_assessment__assessment_number_count,
                                  respondentData.respondent_completed_count
                                )}
                              </div>
                            ) : respondentData.assessment_status__status_name ===
                              "Completed" ? (
                              <div
                                className={
                                  "assessment-status-text " +
                                  addClassName(
                                    respondentData.assessment_status__status_name
                                  )
                                }
                              >
                                {respondentData.assessment_status__status_name}
                                <img src={completed} alt="Completed Image" />
                              </div>
                            ) : (
                              <div
                                className={
                                  "assessment-status-text " +
                                  addClassName(
                                    respondentData.assessment_status__status_name
                                  )
                                }
                              >
                                {respondentData.assessment_status__status_name}
                              </div>
                            )}
                          </td>
                          <td>
                            <div className="actions">
                              <div className="edit-Icon">
                                {editButtonControll(
                                  respondentData.assessor_group__assessor_name,
                                  respondentData.assessor_group__id,
                                  respondentData.user_assessment__id,
                                  respondentData.id,
                                  respondentData.respondent__email,
                                  respondentData.is_submited,
                                  respondentData.assessment_status__status_name
                                )}
                              </div>
                              {deleteButtonControl(
                                respondentData.assessment_status__status_name,
                                respondentData.respondent__email,
                                respondentData.user_assessment__id,
                                respondentData.id,
                                respondentData.is_admin_created
                              )}
                            </div>
                          </td>
                          <td>
                            <div className="Line"></div>
                            <div className="reminder-Icon">
                              {reminderButtonControll(
                                respondentData.assessment_status__status_name,
                                respondentData.respondent__email,
                                respondentData.user_assessment__id,
                                respondentData.respondent__id
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    }
                  )}
              </React.Fragment>
            </tbody>
          </Table>
        )}
      </div>
    </div>
  );
};

export default Sentrespondantsfiltered;



// WEBPACK FOOTER //
// ./src/new/Components/Invitations/Sent/SentRespondentFiltered.jsx